import React from 'react';
import Slider from 'react-slick';
import { STIcon } from 'components/Brand/Icons/STIcon';
import WebsiteImage from 'components/WebsiteImage';
import HyperLink from 'components/Core/HyperLink';
import { getSubheading } from 'utils/text';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { InPageResourceContainer, FeaturedContentSlider } from './styles';

const InPageResource = ({ title, description, inPageNavigationItems, backgroundColor }) => {
  const featuredContents = inPageNavigationItems.filter(
    (item) => item.categoryTitle === 'Featured Content',
  );
  const navigationItems = inPageNavigationItems.filter(
    (item) => item.categoryTitle === 'Navigation',
  );
  const sliderDataLayer = () => {
    dataLayer.push({
      event: 'cta clicked',
      cta_text: 'slider dot',
      cta_position: 'sliderengaged',
    });
  };
  const featureSliderSettings = {
    dots: true,
    dotsClass: 'slick-dots slick-thumb',
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    onSwipe: sliderDataLayer,
  };

  const mobileNavSliderSettings = {
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 3000,
    onSwipe: sliderDataLayer,
  };

  const renderNavigationItems = () => {
    return navigationItems?.map((item, index) => (
      <div className="in-page-resource--navigation-item" key={index}>
        <HyperLink href={item.link} ctaPosition="iconclick" link_text={item.title}>
          <div className="in-page-resource--navigation-item-wrapper">
            <div className="in-page-resource--navigation-icon">
              {item.icon && <WebsiteImage {...item.icon} alt={item.icon.alt} />}
            </div>
            <p className="in-page-resource--navigation-title">{item.title}</p>
          </div>
        </HyperLink>
      </div>
    ));
  };

  return (
    <InPageResourceContainer
      className="in-page-resource--container"
      backgroundColor={backgroundColor}
    >
      <div className="in-page-resource--wrapper">
        <div className="in-page-resource--featured-content">
          <div className="in-page-resource--featured-content-wrapper">
            {featuredContents && (
              <FeaturedContentSlider {...featureSliderSettings}>
                {featuredContents.map((feature, index) => (
                  <div className="in-page-resource--featured-item" key={index}>
                    <div
                      className="in-page-resource--featured-item-wrapper"
                      style={{ backgroundImage: `url(${feature.featuredImage?.image?.file.url})` }}
                    >
                      <HyperLink
                        href={feature.link}
                        ctaPosition="tileclick"
                        ctaText={feature.title}
                      >
                        <div className="in-page-resource--featured-item-content">
                          <h3>{feature.title}</h3>
                          <div className="in-page-resource--featured-item-body min-md">
                            <p>{getSubheading(null, feature.description, 1000)}</p>
                            <div
                              className="in-page-resource--featured-item-link"
                              onClick={(event) => {
                                event.stopPropagation();
                                dataLayer.push({
                                  event: 'cta clicked',
                                  cta_position: 'ctabutton',
                                  cta_text: 'Learn More',
                                  cta_url: feature.link,
                                });
                              }}
                            >
                              Learn More
                            </div>
                          </div>
                        </div>
                      </HyperLink>
                    </div>
                  </div>
                ))}
              </FeaturedContentSlider>
            )}
          </div>
        </div>
        <div className="in-page-resource--main-content">
          <div className="in-page-resource--main-hero">
            <h2 className="font-h1">{title}</h2>
            <p>{description}</p>
          </div>
          <div className="in-page-resource--navigation-items">
            <div className="in-page-resource--navigation-items-wrapper min-md">
              {renderNavigationItems()}
            </div>
            <div className="in-page-resource--navigation-items-wrapper max-md">
              <Slider {...mobileNavSliderSettings}>{renderNavigationItems()}</Slider>
            </div>
          </div>
        </div>
      </div>
    </InPageResourceContainer>
  );
};

export default InPageResource;
